/**
 * 頁籤權限工具函數
 * 提供頁籤權限的解析和檢查功能
 */

// F10103 盤管管理的預設頁籤
export const tabPermissionUtils = {
  F10103_DEFAULT_TABS: [
    'inventory_information',
    'organizational_boundary', 
    'emission_source_identification',
    'importanceIdentification',
    'activity_data',
    'emissions_calculation',
    'inventory',  // 清冊
    'report'
  ],
  
  // F10503 碳足跡盤查的預設頁籤
  F10503_DEFAULT_TABS: [
    'raw_material',           // 原料取得階段
    'manufacturing',          // 製造生產階段
    'distribution',           // 配送運輸階段
    'use_phase',             // 使用階段
    'service_phase',         // 服務階段
    'disposal_phase',        // 廢棄處理階段
    'footprint_calculation',  // 足跡計算
    'data_quality',          // 數據品質
    'sensitivity_analysis',   // 敏感度分析
    'inventory',             // 清冊
    'report'                 // 報告
  ]
};

/**
 * 解析頁籤權限字串
 * @param {string} tabPermissions 頁籤權限字串，格式為 "tab1|tab2|tab3" 或 null
 * @returns {string[]} 頁籤權限列表
 */
export function parseTabPermissions(tabPermissions) {
  if (!tabPermissions || tabPermissions.trim() === '') {
    return []; // 空權限表示無任何頁籤可見
  }
  
  return tabPermissions.split('|')
    .map(tab => tab.trim())
    .filter(tab => tab !== '');
}

/**
 * 檢查用戶是否有特定頁籤的權限
 * @param {string} tabPermissions 頁籤權限字串
 * @param {string} tabName 要檢查的頁籤名稱
 * @returns {boolean} true 如果有權限，false 如果沒有權限
 */
export function hasTabPermission(tabPermissions, tabName) {
  if (!tabName || tabName.trim() === '') {
    return false;
  }
  
  const permissions = parseTabPermissions(tabPermissions);
  return permissions.includes(tabName.trim());
}

/**
 * 檢查用戶是否有任何頁籤權限
 * @param {string} tabPermissions 頁籤權限字串
 * @returns {boolean} true 如果有任何權限，false 如果沒有任何權限
 */
export function hasAnyTabPermission(tabPermissions) {
  const permissions = parseTabPermissions(tabPermissions);
  return permissions.length > 0;
}

/**
 * 將頁籤權限列表轉換為字串格式
 * @param {string[]} tabNames 頁籤名稱列表
 * @returns {string} 頁籤權限字串
 */
export function formatTabPermissions(tabNames) {
  if (!tabNames || tabNames.length === 0) {
    return '';
  }
  
  return tabNames.filter(tab => tab && tab.trim() !== '').join('|');
}
